import { useRef } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

import ImageWithMenu from 'components/Shared/ImageWithMenu/Index'
import FileInput from 'components/Shared/Form/FileInput/Index'

const StyledProfileAvatar = styled.div`
  margin-top: -7px;
  margin-left: 20px;
  display: flex;

  img {
    clip-path: circle(50% at center);
  }
`

const ProfileAvatar = props => {
  const { userAvatarUrl, updateAvatar } = props
  const { t } = useTranslation()
  const fileInputRef = useRef(null)

  const uploadAvatar = (event) => {
    if (event.target.files[0] !== undefined) {
      const data = new FormData()
      data.append('avatar', event.target.files[0])
      updateAvatar(data)
    }
  }

  const openFile = () => {
    fileInputRef.current.click()
  }

  const setDefaultAvatar = () => {
    updateAvatar(null)
  }

  const acceptedTypes = '.jpg, .jpeg, .png, .bmp'

  return (
    <StyledProfileAvatar data-test='profile-avatar'>
      <ImageWithMenu
        img={userAvatarUrl}
        minWidth='144px'
        maxWidth='144px'
        minHeight='144px'
        maxHeight='144px'
        bottomLabel={t('profilePage.avatarChange')}
      >
        <div>
          <a onClick={setDefaultAvatar}>{t('profilePage.defaultImage')}</a>
          <a onClick={openFile}>{t('profilePage.openFile')}</a>
        </div>
      </ImageWithMenu>
      <FileInput
        ref={fileInputRef}
        onChange={uploadAvatar}
        accept={acceptedTypes}
      />
    </StyledProfileAvatar>
  )
}

ProfileAvatar.propTypes = {
  userAvatarUrl: PropTypes.string,
  updateAvatar: PropTypes.func.isRequired,
}

export default ProfileAvatar
